<template>
  <div v-bind:class="getFormStyle()" >
    <el-container v-if='isCollapse' class="login-from-box">
      <el-header class="form-header form-login-header">
        <div v-if='supportNormal && supportWxQR' class="header-title">
          <div :class="!wxVisible ? 'tabs-selected' : 'tabs-normal'" style="padding-right: 12px; text-align: right" @click="loginTab(1)">
            {{ title }}
          </div>
          <div :class="wxVisible ? 'tabs-selected' : 'tabs-normal'" style='text-align: left' @click="loginTab(2)">
            微信扫码登录
          </div>
        </div>
        <div v-else-if='supportNormal' class="header-title">
            <span class="tabs-only-one">
              {{ title }}
            </span>
        </div>
        <div v-else-if='supportWxQR' class="header-title">
            <span class="tabs-only-one">
              微信扫码登录
            </span>
        </div>
      </el-header>
      <el-main class="form-body form-login-main">
        <div v-if="!wxVisible">
          <LoginByUnion v-if="isUnion()"
                        :isCollapse='isCollapse'
                        :supportTypeList="supportTypeList"
                        :accountPlaceholder="accountPlaceholder"
                        @login="handleSubmit"
                        @gotoForgetPwd='gotoForgetPwd'/>
          <LoginByCode v-else-if="isCode()"
                       :isCollapse='isCollapse'
                       :supportTypeList="supportTypeList"
                       :accountPlaceholder="accountPlaceholder"
                       @login="handleSubmit"/>
          <LoginByPwd v-else-if="isPwd()"
                      :isCollapse='isCollapse'
                      :supportTypeList="supportTypeList"
                      :accountPlaceholder="accountPlaceholder"
                      @login="handleSubmit"
                      @gotoForgetPwd='gotoForgetPwd'/>
        </div>
        <div v-else-if="wxVisible">
          <LoginWx :visible.sync="wxVisible" @afterLogin='afterLogin' />
        </div>
      </el-main>
      <el-footer v-if='!wxVisible' class="form-bottom form-bottom-switch">
            <span v-if="otherType !== null"
                  class="form-switch"
                  @click="normalSwitch(otherType)">
              {{ titlesMap.get(otherType) }}
            </span>
      </el-footer>
    </el-container>
    <el-container v-else class='app-login-from-box'>
      <el-header v-if='!wxVisible' class="form-login-header">
        <div class='app-logo'>
          <img src="../../../../assets/logoApp.png" alt="" />
        </div>
        <div v-if='otherTitle.length > 0' class='app-switch' @click='normalSwitch(otherType)'>
          {{otherTitle}}
        </div>
      </el-header>
      <el-main class='form-login-main'>
        <LoginByUnion v-if="isUnion()"
                      :isCollapse='isCollapse'
                      :supportTypeList="supportTypeList"
                      :accountPlaceholder="accountPlaceholder"
                      @login="handleSubmit"
                      @gotoForgetPwd='gotoForgetPwd'
                      @gotoQR='gotoQR'/>
        <LoginByCode v-else-if="isCode()"
                     :isCollapse='isCollapse'
                     :supportTypeList="supportTypeList"
                     :accountPlaceholder="accountPlaceholder"
                     @login="handleSubmit"/>
        <LoginByPwd v-else-if="isPwd()"
                    :isCollapse='isCollapse'
                    :supportTypeList="supportTypeList"
                    :accountPlaceholder="accountPlaceholder"
                    @login="handleSubmit"
                    @gotoForgetPwd='gotoForgetPwd'/>
        <div v-if='supportWxQR && !wxVisible' class="app-qr-btn">
          <span @click="gotoQR()">微信扫码登录</span>
        </div>
        <LoginWx style='border-radius: 8px;' :visible.sync="wxVisible" @afterLogin='afterLogin' />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as LoginType from "@/pages/m/views/login/loginType";
import LoginWx from '@/pages/m/views/login/loginWx.vue'
import LoginByUnion from '@/pages/m/views/login/loginByUnion.vue'
import LoginByCode from '@/pages/m/views/login/loginByCode.vue'
import LoginByPwd from '@/pages/m/views/login/loginByPwd.vue'

const LOGIN_TYPE_SWITCH_UNION = 1;
const LOGIN_TYPE_SWITCH_CODE = 2;
const LOGIN_TYPE_SWITCH_PWD = 3;
const LOGIN_TYPE_SWITCH_QR = 4;
export default {
  name: 'login-switch',
  props: {
    isCollapse: {
      type: Boolean,
      value: false,
    },
    accountPlaceholder: {
      type: String,
      value: '',
    },
    supportTypeList: {
      type: Array,
      value: [],
    }
  },
  data () {
    return {
      activeTab: 1,
      supportNormal: false,
      supportWxQR: false,
      otherType: null,
      currentSwitch: null,
      leftType: null,
      title: '',
      otherTitle: '',
      titlesMap: new Map([
        [LOGIN_TYPE_SWITCH_UNION, '验证码登录'],
        [LOGIN_TYPE_SWITCH_CODE, '验证码登录'],
        [LOGIN_TYPE_SWITCH_PWD, '密码登录'],
      ]),
    }
  },
  components: {
    LoginByPwd,
    LoginByCode,
    LoginByUnion,
    LoginWx,
  },
  watch: {
    supportTypeList() {
      this.updateTypes(this.supportTypeList);
    }
  },
  computed: {
    wxVisible() {
      return this.activeTab === 2;
    }
  },
  mounted() {
    this.updateTypes(this.supportTypeList);
  },
  methods: {
    loginTab (index) {
      console.log('loginTab: index = ', index);
      if (this.activeTab === index) {
        return;
      }
      this.activeTab = index;
      if (index === 1) {
        if (this.currentSwitch !== LOGIN_TYPE_SWITCH_QR) {
          return;
        }
        this.currentSwitch = this.leftType;
        this.leftType = null;
      } else {
        if (this.leftType !== null) {
          return;
        }
        this.leftType = this.currentSwitch;
        this.currentSwitch = LOGIN_TYPE_SWITCH_QR;
      }
    },
    gotoQR() {
      this.loginTab(2);
    },
    gotoForgetPwd() {
      this.$emit('gotoForgetPwd');
    },
    afterLogin (data, index) {
      this.$emit('afterLogin', data, index);
    },
    //登录
    handleSubmit (param) {
      this.$emit('handleSubmit', param);
    },

    updateTypes(types) {
      console.log('updateTypes: types =', types);
      if (LoginType.checkUnionEnable(types)) {
        this.currentSwitch = LOGIN_TYPE_SWITCH_UNION;
        this.otherType = null;
      } else {
        let pwdEnable = LoginType.checkPwdEnable(types);
        let codeEnable = LoginType.checkCodeEnable(types);
        if (codeEnable && pwdEnable) {
          this.currentSwitch = LOGIN_TYPE_SWITCH_PWD;
          this.otherType = LOGIN_TYPE_SWITCH_CODE;
        } else if (pwdEnable) {
          this.currentSwitch = LOGIN_TYPE_SWITCH_PWD;
          this.otherType = null;
        } else if (codeEnable) {
          this.currentSwitch = LOGIN_TYPE_SWITCH_CODE;
          this.otherType = null;
        } else {
          this.currentSwitch = null;
          this.otherType = null;
        }
      }
      this.title = this.titlesMap.get(this.currentSwitch) || '';
      this.otherTitle = this.titlesMap.get(this.otherType) || '';
      this.supportWxQR = this.supportTypeList.includes(LoginType.LOGIN_TYPE_THIRD_WECHAT_QR);
      this.supportNormal = this.currentSwitch !== null;
      console.log('currentSwitch = ', this.currentSwitch);
    },

    normalSwitch(type) {
      if (this.currentSwitch === type) {
        return false;
      }
      let item = this.currentSwitch;
      this.currentSwitch = this.otherType;
      this.otherType = item;
      this.title = this.titlesMap.get(this.currentSwitch) || '';
      this.otherTitle = this.titlesMap.get(this.otherType) || '';
    },

    getFormStyle() {
      if (this.isUnion()) {
        if (!this.supportTypeList.includes(LoginType.LOGIN_TYPE_UNION_PHONE)
            || !this.supportTypeList.includes(LoginType.LOGIN_TYPE_UNION_EMAIL)) {
          return this.isCollapse ? 'union-one-web': 'union-all-app';
        }
        return this.isCollapse ? 'union-all-web' : 'union-all-app';
      }
      return this.isCollapse ? 'non-union-web' : 'union-all-app';
    },

    isUnion() {
      return this.currentSwitch === LOGIN_TYPE_SWITCH_UNION;
    },

    isCode() {
      return this.currentSwitch === LOGIN_TYPE_SWITCH_CODE;
    },

    isPwd() {
      return this.currentSwitch === LOGIN_TYPE_SWITCH_PWD;
    },
  },
}
</script>
